exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.ivu-radio-group-button.ivu-radio-group-large .ivu-radio-wrapper[data-v-b324b39e]{height:32px;line-height:32px;font-size:12px;padding:0px 10px;}\n.ivu-table-cell input[data-v-b324b39e]{text-align: center;}\n", ""]);

// exports
